import { render } from "./MyClones.vue?vue&type=template&id=57b4b412&scoped=true"
import script from "./MyClones.vue?vue&type=script&lang=js"
export * from "./MyClones.vue?vue&type=script&lang=js"

import "./MyClones.vue?vue&type=style&index=0&id=57b4b412&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b4b412"]])

export default __exports__